import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { dashboardUserApi } from '~/utils/api';

export const getAll = async () => dashboardUserApi.get<RcInstanceDTO.Workspace[]>('/workspaces');

export const getOneByShortName = async (orgShortName: string, wsShortName: string) =>
  dashboardUserApi.get<RcInstanceDTO.Workspace>(
    `/workspaceByShortName/${orgShortName}/${wsShortName}`,
  );

export const getWorkspaceInviteByToken = async (token: string) =>
  dashboardUserApi.get<RcInstanceDTO.WorkspaceInviteWithWorkspace>(`/workspaces/invites/${token}`);

export const acceptWorkspaceInvite = async (token: string) =>
  dashboardUserApi.post<string>(`/workspaces/invites/${token}/accept`);
